module.exports = __webpack_public_path__ + "assets/36f99e0a4617f91b73feaaf56a69feea.png";